import { DEFAULT_INTERFACE_THEME, type InterfaceThemeId } from '@kairelo/shared';
import type { InterfaceTheme } from './tokens.js';
import { classicGreenTheme } from './themes/classicGreen.js';

/**
 * Implemented interface themes.
 *
 * Adding one is an identifier in `packages/shared`, an entry here and a token
 * file — no component changes, and nothing in the messaging layer. Themes are
 * named for how they look; see the note on `interfaceThemeIds`.
 */
export const INTERFACE_THEMES: Partial<Record<InterfaceThemeId, InterfaceTheme>> = {
  classic_green: classicGreenTheme,
};

export function getInterfaceTheme(id: InterfaceThemeId | undefined): InterfaceTheme {
  return INTERFACE_THEMES[id ?? DEFAULT_INTERFACE_THEME] ?? classicGreenTheme;
}
